import { createContext, ReactNode, useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../services/api";

interface IUserProviderProps{
  children: ReactNode
}
interface IUserContext{
  name: string;
  modulo: string;
  addTech: (data:IDataTechsPost) => void;
  deleteTech: (id:string) => void
  atualizaTech: (token: string | null) => void
  loading: boolean;
  open: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  techs: ITech[] | null;
  fsetiten: (user: IUserdata)=>void;
  
}
export interface ITech {
  id: string;
  status: string;
  title: string;
  created_at: Date;
  updated_at: Date;
}

interface IUserdata{
  id: string;
  name: string;
  email: string;
  course_module: string;
  bio: string;
  contact: string;
  techs: ITech[] | null ;
}
export interface IUserLogin{
  user: IUserdata;
  token: string;
}

export interface IFormValue{
  email: string;
  password: string;
}

export interface IDataLogin{
  email: string;
  password: string
}
interface IDataTechsPost{
  title: string;
  status: string;
}



export const UserContexts = createContext({} as IUserContext);




export const UserProvider = ({children } : IUserProviderProps) =>{
    const [ name, setName ] = useState<string>("");
    const [ modulo, setModulo] = useState<string>("");
    const [ techs, setTechs ] = useState<ITech[] | null>([]);
    const [ open, setOpen] = useState(false);
    const [ loading , setLoading ] = useState(true)


    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);





    useEffect(() => {
      async function loadUser() {
        const token = localStorage.getItem('KenzieHub-auth');
  
        if (token) {
          try {
            api.defaults.headers.common.authorization = `Bearer ${token}`;
  
            const { data } = await api.get<IUserdata>('/profile');
  
            console.log('busquei usuario', data);
            
            setName(data.name)
            setTechs(data.techs)
            setModulo(data.course_module)
  
          } catch (error) {
            console.error(error);
          }
        }
        setLoading(false);
      }
  
      loadUser();
    }, []);


    const atualizaTech = (token: string | null)=> {
        api.get('/profile', {
          headers: {Authorization: `Bearer ${token}`}
        }).then((resp)=>{setTechs(resp.data.techs)})
        .catch((err)=>console.error(err));
        handleClose();
      };


    const deleteTech = (id:string) => {
        console.log(id)
        const token = localStorage.getItem("KenzieHub-auth");
        console.log(token)
        api.delete(`users/techs/${id}`,{
            headers: {Authorization: `Bearer ${token}`}
          }).then((resp)=>{atualizaTech(token)
            toast.warning("Tech removida")
            })
          .catch((err)=>console.error(err));
    };



  const addTech =  (data:IDataTechsPost) => {
    console.log(data)
    const token = localStorage.getItem('KenzieHub-auth')
    api.post("users/techs", data, {
      headers: {Authorization: `Bearer ${token}`}
    })
    .then((response)=> {
      atualizaTech(token)
      toast.success("Tech adicionada com sucesso!")
      })
    .catch((err)=>console.error(err));
};

const fsetiten = (user: IUserdata)=>{
  setModulo(user.course_module);
  setName(user.name);
  setTechs(user.techs);
}

      return(
        <UserContexts.Provider 
        value={{ name, modulo, addTech, deleteTech, atualizaTech,
        loading, fsetiten,
        techs, open, handleClose, handleOpen }}>
            {children}
        </UserContexts.Provider>

    )
}